import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

import { APEX_CREDIT_PURCHASE_MODAL } from './constants'
import { canLoadNavigation } from './helpers'

const ApexCreditPurchaseContainerModal = Loadable(() => import('./ApexCreditPurchaseContainerModal'))

export const createApexCreditPurchaseNavigationItem = (translateFn, ...rest) => {
  const permissions = rest[rest.length - 1]

  if (canLoadNavigation(permissions)) {
    return createNavigationConfig((translateFn) => ({
      icon: 'hypothec',
      text: translateFn('mnu_credit_purchase'),
      identity: APEX_CREDIT_PURCHASE_MODAL,
      component: ApexCreditPurchaseContainerModal,
    }))(translateFn, ...(rest as [Function]))
  }
}
